<template>
  <v-progress-linear
    data-vue-component-name="ProgressBar"
    :value="value"
    rounded
    height="12"
    background-color="secondary"
    color="progressBar"
  />
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
[data-vue-component-name="ProgressBar"] {
  max-width: 400px;
  width: 100%;
}
</style>
